module.exports = __webpack_public_path__ + "img/add.f2513c61.svg";